<template>
  <BaseVeeForm
    :action="submitForm"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    class="space-y-8"
  >
    <div class="p-4 sm:p-6">
      <ValidationProvider rules="required" name="content" slim vid="content">
        <template #default="{ errors }">
          <BaseFormGroup>
            <VTextEditor
              :custom-editor-classes="['min-h-64']"
              :content="formData.content"
              :read-only="isPending"
              @input="formData.content = $event"
            />
            <input type="hidden" name="content" :value="formData.content" />
            <BaseFormInlineMessage v-if="errors.length" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>
      <div class="space-x-2 mt-4 sm:mt-6">
        <BaseButton type="submit" primary small :disabled="isPending || invalid"> Save </BaseButton>

        <BaseButton type="button" ghost small :disabled="isPending" @click="$emit('cancel')">
          Cancel
        </BaseButton>
      </div>
    </div>
  </BaseVeeForm>
</template>

<script>
import VTextEditor from 'Components/Common/VTextEditor.vue';

export default {
  components: {
    VTextEditor,
  },
  props: {
    submitAction: {
      type: Function,
      required: true,
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {
        content: this.content,
      },
    };
  },
  methods: {
    async submitForm() {
      try {
        await this.submitAction(this.formData);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
